export const themes = [
  { id: 'emerald', name: 'Verde', color: '#24635d', dark: '#102f2d', menu: '#1d514d', description: 'Tema padrão' },
  { id: 'ocean', name: 'Azul', color: '#245d8f', dark: '#102b42', menu: '#1d4b70', description: 'Sóbrio e profissional' },
  { id: 'indigo', name: 'Índigo', color: '#5252a3', dark: '#252447', menu: '#42417f', description: 'Moderno e elegante' },
  { id: 'wine', name: 'Vinho', color: '#7b394d', dark: '#371923', menu: '#622e3d', description: 'Marcante e refinado' },
  { id: 'graphite', name: 'Grafite', color: '#46535a', dark: '#20282c', menu: '#39464d', description: 'Neutro e discreto' },
  { id: 'orange', name: 'Laranja', color: '#d96b20', dark: '#5c2508', menu: '#9a4314', description: 'Quente e vibrante' },
  { id: 'pink', name: 'Rosa', color: '#db2777', dark: '#500724', menu: '#9d174d', description: 'Delicado e moderno' },
];

export function getTheme(themeId) {
  return themes.find(theme => theme.id === themeId) || themes[0];
}

export function applyTheme(themeId) {
  const selectedTheme = themes.some(theme => theme.id === themeId) ? themeId : 'emerald';
  document.documentElement.setAttribute('data-theme', selectedTheme);
  return selectedTheme;
}
